<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">

        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="配置id">
              <a-input placeholder="请输入配置id模糊查询" v-model="queryParam.setId"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="配置名称">
              <a-input placeholder="请输入配置id模糊查询" v-model="queryParam.setName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="源头业务表">
              <a-input placeholder="请输入源头业务表" v-model="queryParam.dataTable"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="目标业务表">
              <a-input placeholder="请输入目标业务表" v-model="queryParam.targetTable"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="源头明细表">
              <a-input placeholder="请输入源头明细表" v-model="queryParam.detailDataTable"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="目标明细表">
              <a-input placeholder="请输入源头明细表" v-model="queryParam.detailTargetTable"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="是否有序">
              <j-dict-select-tag placeholder="请选择是否有序" v-model="queryParam.haveSeq" dictCode="yn" />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="分组编码">
              <a-input placeholder="请输入分组编码" v-model="queryParam.groupNo"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="状态">
              <j-dict-select-tag placeholder="请选择状态" v-model="queryParam.status" dictCode="data_sync_status" />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="定时任务">
              <m-ore-select :showType="true"
                            showTypeName="jobDesc"
                            showTypeValue="id"
                            v-model="queryParam.jobId"
                            url="/base/busDataSyncBaseSet/getXxlJobList"
                            :asterisk="false"
                            :params="{}"
                            placeholder="请选择定时任务">
              </m-ore-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('bus_data_sync_doc_main_set')">导出</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, type:'radio' }"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无此图片</span>
          <img
            v-else
            :src="getImgView(text)"
            height="25px"
            alt="图片不存在"
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无此文件</span>
          <a-button v-else :ghost="true" type="primary" icon="download" size="small" @click="uploadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleSynchronization(record, 1)">同步中心表结构</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleSynchronization(record, 2)">同步数据</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="明细" key="1" >
        <bus-data-sync-doc-detail-set-list :mainSetId="selectedMainSetId" />
      </a-tab-pane>
    </a-tabs>

    <busDataSyncDocMainSet-modal ref="modalForm" @ok="modalFormOk"></busDataSyncDocMainSet-modal>
  </a-card>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import BusDataSyncDocMainSetModal from './modules/BusDataSyncDocMainSetModal'
import BusDataSyncDocDetailSetList from './BusDataSyncDocDetailSetList'
import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
import { postAction } from '@/api/manage'
import JInput from '@/components/jeecg/JInput'
import MOreSelect from './modules/NAmeMOreSelect.vue'
export default {
  name: 'BusDataSyncDocMainSetList',
  mixins: [JeecgListMixin],
  components: {
    BusDataSyncDocDetailSetList,
    BusDataSyncDocMainSetModal,
    JInput,
    MOreSelect
  },
  data() {
    return {
      description: 'bus_data_sync_doc_main_set管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '配置id',
          align: 'center',
          dataIndex: 'setId',
        },
        {
          title: '配置名称',
          align: 'center',
          dataIndex: 'setName',
        },
        {
          title: '源头数据库',
          align: 'center',
          dataIndex: 'sourceCode_dictText',
        },
        {
          title: '源头业务表',
          align: 'center',
          dataIndex: 'dataTable',
        },
        {
          title: '目标业务表',
          align: 'center',
          dataIndex: 'targetTable',
        },
        {
          title: '是否有序',
          align: 'center',
          dataIndex: 'haveSeq_dictText',
        },
        {
          title: '顺序',
          align: 'center',
          dataIndex: 'sequence',
        },
        {
          title: '分组编码',
          align: 'center',
          dataIndex: 'groupNo',
        },
        {
          title: '定时任务',
          align: 'center',
          dataIndex: 'jobDesc',
        },
        {
          title: '备注',
          align: 'center',
          dataIndex: 'remarks',
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'status_dictText',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/datadocsync.base/busDataSyncDocMainSet/list',
        delete: '/datadocsync.base/busDataSyncDocMainSet/delete',
        exportXlsUrl: '/datadocsync.base/busDataSyncDocMainSet/exportXls',
        centerTableStruct: '/datadocsync.base/busDataSyncDocMainSet/centerTableStruct', //同步中心表结构
        dataSync: '/datadocsync.base/busDataSyncDocMainSet/dataSync', //同步数据
      },
      dictOptions: {},
      selectedMainSetId:''
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    initDictConfig() {},
    handleSynchronization(record, index) {
      if (index == 1) {
        // postAction(this.url.centerTableStruct, { setId: record.setId }).then((res) => {
        //   console.log(res)
        //   if (res.code == 200) {
        //     that.$message.success(title + ',成功')
        //     that.loadData()
        //     that.onClearSelected()
        //   } else {
        //     that.$message.warning(res.message)
        //   }
        // })
        this.requestSynchronization(this.url.centerTableStruct, { setId: record.setId }, '同步中心表结构')
      } else {
        this.requestSynchronization(this.url.dataSync, { setId: record.setId }, '同步数据')
      }
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
      this.selectedMainSetId='';
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedMainSetId = selectionRows[0].setId;
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    requestSynchronization(url, record, title) {
      const that = this
      postAction(url, record).then((res) => {
        // postAction(url, record).then((res) => {
        console.log(res)
        if (res.code == 200) {
          that.$message.success(title + ',成功')
          that.loadData()
          that.onClearSelected()
        } else {
          that.$message.warning(res.message)
        }
      })
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
